/// <reference types="./account.d.mts" />
import * as $bright from "../../../../bright/bright.mjs";
import * as $user from "../../../../common/data/user.mjs";
import * as $button from "../../../../ds/ds/components/button.mjs";
import * as $copy_button from "../../../../ds/ds/components/copy_button.mjs";
import * as $input from "../../../../ds/ds/components/input.mjs";
import * as $l from "../../../../ds/ds/components/layout.mjs";
import * as $profile_picture from "../../../../ds/ds/components/profile_picture.mjs";
import * as $skeleton from "../../../../ds/ds/components/skeleton.mjs";
import * as $option from "../../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../../gleam_stdlib/gleam/option.mjs";
import * as $el from "../../../../lustre/lustre/element.mjs";
import * as $e from "../../../../lustre/lustre/event.mjs";
import * as $mode from "../../../../vitools/vitools/mode.mjs";
import * as $model from "../../../data/model.mjs";
import * as $state from "../../../data/model/state.mjs";
import * as $msg from "../../../data/msg.mjs";
import * as $common from "../../../frontend/view/common.mjs";
import { Ok, toList } from "../../../gleam.mjs";

function view_profile_picture(user) {
  return $skeleton.hide_loading(
    user,
    128,
    128,
    (user) => {
      let size = new $profile_picture.Humongous();
      return $profile_picture.from_user(user.picture, user.initials, size);
    },
  );
}

function view_name_input(user) {
  if (user instanceof Ok) {
    let user$1 = user[0];
    return $l.column(
      toList([$l.gap(16), $l.align("start")]),
      toList([]),
      toList([
        $input.input(
          toList([
            $input.label("Name"),
            $input.placeholder("John Doe"),
            $input.value(user$1.name),
            $input.disabled(true),
          ]),
        ),
      ]),
    );
  } else {
    return $l.column(
      toList([$l.gap(16), $l.align("start")]),
      toList([]),
      toList([$skeleton.skeleton(80, 20), $skeleton.skeleton(200, 45)]),
    );
  }
}

function view_email_input(user) {
  if (user instanceof Ok) {
    let user$1 = user[0];
    return $l.column(
      toList([$l.gap(8), $l.align("start")]),
      toList([]),
      toList([
        $input.input(
          toList([
            $input.value(user$1.email),
            $input.disabled(true),
            $input.label("Email"),
          ]),
        ),
      ]),
    );
  } else {
    return $l.column(
      toList([$l.gap(16), $l.align("start")]),
      toList([]),
      toList([$skeleton.skeleton(80, 20), $skeleton.full_width(45)]),
    );
  }
}

function disconnect() {
  return $l.row(
    toList([$l.justify("end")]),
    toList([]),
    toList([
      $button.primary(
        toList([$e.on_click(new $msg.UserDisconnected())]),
        toList([$el.text("Log out")]),
      ),
    ]),
  );
}

function user_data(model) {
  let state = $bright.state(model);
  let user = $state.current_user(state);
  let is_admin = $option.map(user, $user.is_super_admin);
  let $ = state.user;
  let $1 = $mode.dev();
  if ($ instanceof Some) {
    if ($1) {
      let user$1 = $[0];
      let $2 = user$1.org_id;
      if ($2 instanceof Some) {
        let org_id = $2[0];
        return $l.fragment(
          toList([
            $l.row(
              toList([$l.gap(8), $l.align("baseline")]),
              toList([]),
              toList([
                $common.user_info(
                  toList([]),
                  toList([
                    $el.text(org_id),
                    $copy_button.copy_button(
                      toList([$copy_button.content(org_id)]),
                    ),
                  ]),
                ),
                $common.user_info(
                  toList([]),
                  toList([
                    $el.text(user$1.sub),
                    $copy_button.copy_button(
                      toList([$copy_button.content(user$1.sub)]),
                    ),
                  ]),
                ),
              ]),
            ),
          ]),
        );
      } else {
        return $el.none();
      }
    } else if (is_admin instanceof Some) {
      let $2 = is_admin[0];
      if ($2) {
        let user$1 = $[0];
        let $3 = user$1.org_id;
        if ($3 instanceof Some) {
          let org_id = $3[0];
          return $l.fragment(
            toList([
              $l.row(
                toList([$l.gap(8), $l.align("baseline")]),
                toList([]),
                toList([
                  $common.user_info(
                    toList([]),
                    toList([
                      $el.text(org_id),
                      $copy_button.copy_button(
                        toList([$copy_button.content(org_id)]),
                      ),
                    ]),
                  ),
                  $common.user_info(
                    toList([]),
                    toList([
                      $el.text(user$1.sub),
                      $copy_button.copy_button(
                        toList([$copy_button.content(user$1.sub)]),
                      ),
                    ]),
                  ),
                ]),
              ),
            ]),
          );
        } else {
          return $el.none();
        }
      } else {
        return $el.none();
      }
    } else {
      return $el.none();
    }
  } else {
    return $el.none();
  }
}

export function view(model) {
  let state = $bright.state(model);
  let user = $state.find_current_user(state);
  return $l.fragment(
    toList([
      $common.underlined_title(
        toList([]),
        toList([
          $l.row(
            toList([$l.gap(24), $l.white_space("nowrap"), $l.align("baseline")]),
            toList([]),
            toList([$el.text("My profile"), user_data(model)]),
          ),
          $common.separator(),
        ]),
      ),
      $l.row(
        toList([$l.gap(30), $l.align("start")]),
        toList([]),
        toList([view_profile_picture(user), view_name_input(user)]),
      ),
      $common.underlined_title(
        toList([]),
        toList([$el.text("Email"), $common.separator()]),
      ),
      view_email_input(user),
      disconnect(),
    ]),
  );
}
